import { Controller } from '@hotwired/stimulus'
// #AI: jQuery is loaded via Sprockets as a global variable
const $ = window.jQuery || window.$;

const setToClipboard = async (blob: Blob) => {
  const data = [new ClipboardItem({ [blob.type]: blob })]
  await navigator.clipboard.write(data)
}

export default class extends Controller {
  static targets = ['qrButton', 'qrImageTag']

  declare qrButtonTarget: HTMLElement
  declare qrImageTagTarget: HTMLImageElement

  qrButtonClicked(event: Event) {
    const target = event.target as HTMLElement
    this.copyQrImageToClipBoard(this.qrImageTagTarget, target)
  }

  async copyQrImageToClipBoard(sourceImageTag: HTMLImageElement, sourceButton: HTMLElement) {
    const src = sourceImageTag.getAttribute('src')
    if (src) {
      const response = await fetch(src)
      const blob = await response.blob()
      await setToClipboard(blob)
      const originalContent = sourceButton.innerHTML
      sourceButton.innerHTML = 'Copied!'
      setTimeout(() => {
        sourceButton.innerHTML = originalContent
      }, 1000)
    }
  }
}
